import { AnyAction } from "redux";
import { FETCH_TEACHERS, RECEIVE_TEACHERS, SAVE_TEACHER, SAVE_TEACHER_SUCCESS, DELETE_TEACHER, DELETE_TEACHER_SUCCESS } from "../actionTypes";

interface TeacherState {
    isFetching: boolean;
    isSaving: boolean;
    teachers: any[];
}

const initialState: TeacherState = {
    isFetching: false,
    isSaving: false,
    teachers: [],
}

const teacherReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_TEACHERS: return { ...state, isFetching: true };
        case RECEIVE_TEACHERS: return { ...state, isFetching: false, teachers: action.payload };
        case SAVE_TEACHER: return { ...state, isSaving: true };
        case SAVE_TEACHER_SUCCESS: return { ...state, isSaving: false };
        case DELETE_TEACHER: return { ...state, isSaving: true };
        case DELETE_TEACHER_SUCCESS: return { ...state, isSaving: false };
        default: return state;
    }
}
export default teacherReducer;
